/**
 * @author  Agence Dn'D <contact@dnd.fr>
 * @license https://opensource.org/licenses/osl-3.0.php  Open Software License (OSL 3.0)
 * @link    https://www.dnd.fr/
 */

(() => {
    'use strict';

    const supportsAnimationTimeline = () => {
        const supports = CSS.supports('animation-timeline', 'scroll()') ||
            CSS.supports('animation-timeline', 'scroll(root)');
        return supports;
    };

    if (supportsAnimationTimeline()) {
        return;
    }

    class LogoScrollAnimation {
        constructor() {
            this.logo = null;
            this.isActive = false;
            this.rafId = null;

            this.mobileKeyframes = {
                from: { top: 60, width: 340 },
                to: { top: 0, width: 140 }
            };

            this.desktopKeyframes = {
                from: { top: 60, width: 490 },
                to: { top: 0, width: 170 }
            };

            this.scrollStart = 0;
            this.scrollEnd = 200;
        }

        getKeyframes = () => {
            const isDesktop = window.innerWidth >= 767.98;
            return isDesktop ? this.desktopKeyframes : this.mobileKeyframes;
        }

        lerp = (start, end, progress) => {
            return start + (end - start) * progress;
        }

        getScrollProgress = () => {
            const scrollY = window.scrollY || window.pageYOffset;

            if (scrollY <= this.scrollStart) {
                return 0;
            }

            if (scrollY >= this.scrollEnd) {
                return 1;
            }

            const progress = (scrollY - this.scrollStart) / (this.scrollEnd - this.scrollStart);
            return Math.max(0, Math.min(1, progress));
        }

        animate = () => {
            if (!this.logo) return;

            const progress = this.getScrollProgress();
            const keyframes = this.getKeyframes();

            const currentTop = this.lerp(keyframes.from.top, keyframes.to.top, progress);
            const currentWidth = this.lerp(keyframes.from.width, keyframes.to.width, progress);

            this.logo.style.setProperty('top', `${currentTop}px`, 'important');
            this.logo.style.setProperty('width', `${currentWidth}px`, 'important');
        }

        start = () => {
            if (this.isActive) return;
            this.isActive = true;
            this.update();
        }

        stop = () => {
            this.isActive = false;
            if (this.rafId) {
                cancelAnimationFrame(this.rafId);
                this.rafId = null;
            }
        }

        update = () => {
            if (!this.isActive) return;

            this.animate();
            this.rafId = requestAnimationFrame(this.update);
        }

        handleResize = () => {
            this.animate();
        }

        init = () => {
            if (!document.body.classList.contains('template-index')) {
                return;
            }

            this.logo = document.querySelector('.template-index .pageheader .logo-area__middle--logo-image');

            if (!this.logo) {
                return;
            }

            this.start();

            window.addEventListener('resize', this.handleResize);

            window.addEventListener('beforeunload', () => {
                this.stop();
                window.removeEventListener('resize', this.handleResize);
            });
        }

        destroy = () => {
            this.stop();
            window.removeEventListener('resize', this.handleResize);
        }
    }

    const initLogoAnimation = () => {
        const logoAnimation = new LogoScrollAnimation();
        logoAnimation.init();
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initLogoAnimation);
    } else {
        initLogoAnimation();
    }
})();